import * as Blockly from 'blockly/core'
import { Order } from 'blockly/lua'
import { BlockDefinition, numberOutput } from './common'

export const emptyNumberExtensionName = 'empty_number_extension'
export const emptyNumberFieldName = 'EMPTY_NUMBER'

export const emptyNumberToCode = (
  value: string,
  valueIfEmpty = '0',
  parse = parseFloat,
): string => {
  const float = parse(value)
  if (isNaN(float)) {
    return valueIfEmpty
  }
  return float.toString()
}

// 全角を半角に変換する関数
const convertFullWidthToHalfWidth = (str: string): string => {
  return str
    .replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0))
    .replace(/[Ｅｅえ]/g, 'e')
    .replace(/[。.]/g, '.')
    .replace(/[‐－―ー]/g, '-')
}

const validateEmptyNumber = (
  newValue: string,
  parse = parseFloat,
): string | null => {
  if (newValue === '') {
    return ''
  }
  // 全角を半角に変換
  const convertedValue = convertFullWidthToHalfWidth(newValue)

  // チェック: 数値として解析可能かどうか
  const val = parse(convertedValue)
  if (isNaN(val)) {
    return null
  }

  // 有効な数値なら、変換後の値を返す
  return val.toString()
}

Blockly.Extensions.register(
  emptyNumberExtensionName,
  function (this: Blockly.Block) {
    this.getInput(emptyNumberFieldName)?.appendField(
      new Blockly.FieldTextInput('', (newValue: string) =>
        validateEmptyNumber(newValue),
      ),
      'VAL',
    )
  },
)

export const emptyNumberDefaults: Partial<BlockDefinition> = {}

export const emptyNumberBlocks: Array<BlockDefinition> = [
  {
    // For use as a shadow block for inputs that should accept floating-point numbers or the empty string.
    // If the input is empty, the block will output the empty string (i.e., no code).
    opcode: 'math_empty_number_empty_string',
    ...numberOutput,
    args0: [{ type: 'input_dummy', name: emptyNumberFieldName }],
    generator: (block: Blockly.Block) => [
      emptyNumberToCode(block.getFieldValue('VAL'), ''),
      Order.ATOMIC,
    ],
    extensions: [emptyNumberExtensionName],
    message0: '%1',
  },
  {
    // For use as a shadow block for inputs that should accept floating-point numbers or the empty string.
    // If the input is empty, the block will output zero.
    opcode: 'math_empty_number_zero',
    ...numberOutput,
    args0: [{ type: 'input_dummy', name: emptyNumberFieldName }],
    generator: (block: Blockly.Block) => [
      emptyNumberToCode(block.getFieldValue('VAL'), '0'),
      Order.ATOMIC,
    ],
    extensions: [emptyNumberExtensionName],
    message0: '%1',
  },
]
